interface IProps {
    id: number,
    alias: string,
    centerId: number,
    isRecipientCenter: boolean
}

const RecipientAlias = (props: IProps) => {
    if (props.isRecipientCenter) {
        return (
            <a href={`center/${props.centerId}/recipient/${props.id}/profile/general`} target='_blank'>{props.alias}</a>
        )
    }

    return (
        <>{props.alias}</>
    );
};

export default RecipientAlias;